import { Config, ConfigInterface } from '../section/section';

export type TechnologyConfigInterface = ConfigInterface;

export class TechnologyConfig extends Config implements TechnologyConfigInterface {
  constructor(data: TechnologyConfigInterface) {
    super(data);
  }
}
